<template>
  <div class="order-panel-list">
    <Spinner v-if="loading" />
    <p v-if="!userHasReadPermission(PermissionTypes.OrderPermissionTypes.order)">
      Payments not accessible
    </p>
    <div v-if="!loading && userHasReadPermission(PermissionTypes.OrderPermissionTypes.order)">
      <p class="text-danger font-weight-bold" v-if="loadingError">{{loadingError}}</p>

      <div v-if="!hasPayments">No direct payments yet assigned to this order</div>
      <div v-if="hasPayments">
        <p>Direct payments associated with this order:</p>
        <ItemPanelList class="mt-2">
          <ItemPanel v-for="payment of linkedOverPayments" :key="payment.id" icon="fa-usd-circle">
            <template v-slot:title>
              <ActionDropMenu class="float-right" buttonClass="btn-xxs" :forceDropdown="true">
                <DropdownMenuItem @click="sendPaymentReceipt(payment)" icon="fa-envelope" v-if="isPaymentReceiptSendable(payment)">Send Payment Receipt</DropdownMenuItem>
              </ActionDropMenu>
              <strong>
                <LinkOverPayment :id="payment.id" name="Direct Payment" />
              </strong>
            </template>
            <template v-slot:description>
              {{payment.sequenceNumber}}
            </template>
            <template v-slot:content>
              <ItemPanelData title="Status">
                <LabelBadge :labelClass="`label-payment-status-${payment.status}`">{{payment.status | formatLookupName(OverpaymentStatusTypeLookup)}}</LabelBadge>
              </ItemPanelData>
              <ItemPanelData title="Payment">
                <LabelBadge :labelClass="`label-payment-type-${payment.paymentReceived.paymentType}`">{{payment.paymentReceived.paymentType | formatLookupName(PaymentTypeLookup)}}</LabelBadge>
              </ItemPanelData>
              <ItemPanelData title="Date">
                {{payment.dateCreated | formatDateTime}}
              </ItemPanelData>
              <ItemPanelData title="Amount">
                <strong>{{payment.amount | formatCurrency}}</strong>
              </ItemPanelData>
            </template>
          </ItemPanel>
        </ItemPanelList>
      </div>
    </div>
  </div>
</template>

<script>
import FormMixin from '@/mixins/form'
import { PaymentStatusTypeLookup, PaymentTypeLookup, OverpaymentStatusTypes, OverpaymentStatusTypeLookup } from '@/store/types'

import SendPaymentReceivedDialog from '@/modules/accounts/views/sendPaymentReceivedDialog'

export default {
  name: 'OrderPaymentList',
  mixins: [FormMixin],
  props: {
    orderId: Number
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      linkedOverPayments: []
    }
  },
  watch: {
    orderId: function() {
      this.reloadData()
    }
  },
  computed: {
    hasPayments() {
      return this.linkedOverPayments.length > 0
    }
  },
  created() {
    this.PaymentStatusTypeLookup = PaymentStatusTypeLookup
    this.PaymentTypeLookup = PaymentTypeLookup
    this.OverpaymentStatusTypeLookup = OverpaymentStatusTypeLookup
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loadingError = ''

      this.loading = true
      this.$apiService.ordersService.getOrderPayments(this.orderId)
      .then(response => {
        this.linkedOverPayments = response.data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
    reloadData() {
      this.requestData()
    },
    sendPaymentReceipt(overPayment) {
      if(!overPayment.paymentReceived)
        return

      this.displayModal(SendPaymentReceivedDialog, { 
        paymentReceivedId: parseInt(overPayment.paymentReceivedId),
        contactId: parseInt(overPayment.paymentReceived.contactId)
      })
      .then((success) => {
        if(success) {
          this.successToast('Receipt Sent')
          this.reloadData()
        }
      })
    },
    isPaymentReceiptSendable(overPayment) {
      if(!this.userHasCreatePermission(this.PermissionTypes.AccountsPermissionTypes.orderEntryPayment))
        return false
      if(overPayment.status == OverpaymentStatusTypes.cancelled)
        return false
      return true
    }
  }


}
</script>